// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js!./vue-treeselect.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("0f77addb", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/@riophae/vue-treeselect/dist/vue-treeselect.css
// module id = 12
// module chunks = 0